import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "issue-close",
  "use": "issue-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"issue-close\"><title>icn/issue-close</title><path d=\"M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0-2A5 5 0 1 0 8 3a5 5 0 0 0 0 10zM6 7h4a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2z\" id=\"issue-close_a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol